import { Controller } from "@hotwired/stimulus";
import moment from "moment";
import * as echarts from "echarts";

export default class extends Controller {
  static targets = ["chartBody"];

  connect() {
    this.chart = null;
    this.initializeChart();
  }

  initializeChart() {
    if (!this.hasChartBodyTarget) {
      return;
    }
    const colorPref =
      document.documentElement.getAttribute("data-bs-theme") === "dark"
        ? "dark"
        : "light";

    this.chart = echarts.init(this.chartBodyTarget);
    this.chart.setOption({
      tooltip: {
        trigger: "axis",
        axisPointer: {
          label: {
            formatter: function (params) {
              return moment(params.value).format("dddd, MMM D, h:mm a");
            },
          },
        },
      },
      legend: {
        orient: "horizontal",
        icon: "circle",
        textStyle: {
          color: colorPref == "light" ? "#333" : "#E2DBDD",
        },
      },
      xAxis: {
        type: "time",
      },
      yAxis: {
        type: "value",
      },
      dataZoom: [
        {
          start: 0,
          end: 100,
        },
      ],
      series: [
        {
          stack: "Notices",
          name: "Stored",
          type: "bar",
          barWidth: "99%",
          color: ["#00A9A5"],
          emphasis: {
            focus: "series",
          },
        },
        {
          stack: "Notices",
          name: "Limited",
          type: "bar",
          barWidth: "99%",
          color: [colorPref == "light" ? "#EF592B" : "#CA1628"],
          emphasis: {
            focus: "series",
          },
        },
        {
          stack: "Notices",
          name: "Ignored",
          type: "bar",
          barWidth: "99%",
          color: [colorPref == "light" ? "#222529" : "#BDB4AD"],
          emphasis: {
            focus: "series",
          },
        },
      ],
      grid: {
        containLabel: true,
        left: "0",
        right: "15",
        top: "10%",
        bottom: "10%",
      },
    });
  }

  updateData(e) {
    this.noticeVolumeData = e.detail.data;
    this.redrawChart();
  }

  redrawChart() {
    if (!this.chart) {
      return;
    }

    this.chart.setOption({
      series: this.noticeVolumeData.series,
      xAxis: {
        min: this.noticeVolumeData.start_at,
        max: this.noticeVolumeData.end_at,
      },
    });
  }

  resizeChart() {
    if (!this.chart) {
      return;
    }

    this.chart.resize();
  }
}
